<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Thông báo</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
<!--             <el-form-item prop="image" label="Ảnh bìa Page">
              <el-upload
                class="blogs-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="blogs">
                <i v-else class="el-icon-plus blogs-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh bìa Page có dung lượng tối đa tải lên là 2Mb (up load ảnh kích thước 850 * 400 để hiện thị lên site đẹp nhất)
                </div>
              </el-upload>
            </el-form-item> -->
            <!-- <el-form-item prop="name" label="Tiêu đề Page" class="form-item">
              <el-input v-model="modelData.name" class="input-seach"></el-input>
            </el-form-item> -->
            <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" v-model="modelData.description" class="input-seach"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="content" label="Nội dung" class="form-item">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="modelData.content" class="input-seach"></el-input>
            </el-form-item> -->

            <el-form-item prop="content" label="Nội dung">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '300px', images_upload_handler: handleImageAdded , language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item prop="note" label="Ghi chú" class="form-item">
              <el-input v-model="modelData.note" class="input-seach" placeholder="Ghi chú nếu có"></el-input>
            </el-form-item>
<!--             <el-form-item prop="content" label="Nội dung Page">
              <tinymce
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', images_upload_handler: handleImageAdded , language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item> -->

            <el-row :gutter="15">
              <el-col :span="6">
                <el-form-item prop="user_code" label="Mã tài khoản cần gửi" class="form-item">
                  <el-input v-model="modelData.user_code" class="input-seach" placeholder="cati-000001"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item prop="list_user_type" label="Nhóm tài khoản cần gửi" class="form-item">
                  <el-checkbox-group v-model="modelData.list_user_type">
                      <el-checkbox v-for="city in lists.listUserType" :label="city.key" :key="city.key">{{city.value}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'NotificationCreate',
  metaInfo () {
    return {
      title: 'Thông báo'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        description: '',
        content: '',
        user_code: '',
        list_user_type: [],
        status: true
      },
      lists: {
        listCategoryBlogs: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listUserType: [
          {key: 2, value: 'Giảng viên'},
          {key: 3, value: 'Học viên'},
          {key: 9, value: 'Cộng tác viên'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'notifications/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        description: [
          { required: true, message: 'Vui lòng nhập mô tả ngắn' },
          { min: 2, max: 191, message: 'Mô tả ngắn có chiều dài từ 2 tới 191 kí tự' }
        ],
        content: [
          { required: true, message: 'Vui lòng nhập nội dung' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.configUpload()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('notifications/upload', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'notifications-index', text: 'Thông báo' },
        { name: 'notifications-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'notifications-index'})
    },
    // Fetch dữ liệu về lĩnh vực Page
    fetchListCategoryBlogs () {
      axios.get('category-notifications', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryBlogs = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('notifications', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thông báo thành công',
              type: 'success'
            })
            this.$router.push({name: 'notifications-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh Page có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.blogs {
  width: 840px;
  height: 300px;
  display: block;
  object-fit: cover;
}
</style>

<style type="text/css">
.blogs-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.blogs-uploader .el-upload:hover {
  border-color: #409EFF;
}
.blogs-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 840px;
  height: 300px;
  line-height: 300px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/Create.vue